import * as React from "react";
import { Timeline as MantineTimeline } from "@mantine/core";
const Timeline = ({ children = void 0, bulletSize, color, active, className = void 0 }) => /* @__PURE__ */ React.createElement(MantineTimeline, { bulletSize, color, className, active }, children);
Timeline.Item = MantineTimeline.Item;
export default Timeline;
